import { env } from "../env";

let initialized = false;
let initializing: Promise<void> | null = null;

export function initSentry() {
  if (initialized || initializing) {
    return;
  }

  // Load the browser bundle only on the client. The package's server export
  // does not include browserTracingIntegration(), which breaks SSR startup.
  initializing = import("@sentry/tanstackstart-react")
    .then(({ browserTracingIntegration, init }) => {
      if (initialized) {
        return;
      }

      init({
        dsn: env.VITE_SENTRY_DSN,
        integrations: [browserTracingIntegration()],
        sendDefaultPii: true,
        tracesSampleRate: 1.0,
      });

      initialized = true;
    })
    .finally(() => {
      initializing = null;
    });
}
